export default __webpack_public_path__ + "static/media/t3.b3835501.png";